module.exports = __webpack_public_path__ + "img/1479026954.8a3ca6d4.jpg";